var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="index_empty"> <div class="row"> <div class="col-sm-12"> <div class="row"> <h3 class="text-dark font-weight-bold mb-0 mr-5">Welcome to Dashboard</h3> <div id="contentRegion"></div> </div> </div> </div> </div>';
}
return __p;
};
